/**
 * Google Analytics y Event Tracking
 */

// Inicializar Google Analytics (patrón oficial dataLayer — gtag.q no envía hits)
export const initGA = (trackingId) => {
  if (typeof window === 'undefined' || !trackingId) return;

  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  const scriptSrc = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
  if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
    const script = document.createElement('script');
    script.async = true;
    script.src = scriptSrc;
    document.head.appendChild(script);
  }

  window.gtag('js', new Date());
  window.gtag('config', trackingId);
};

// Track page view
export const trackPageView = (path) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', process.env.REACT_APP_GA_TRACKING_ID, {
      page_path: path
    });
  }
};

// Track e-commerce events
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

// E-commerce specific events
export const trackAddToCart = (product) => {
  trackEvent('add_to_cart', {
    currency: 'COP',
    value: product.price * (product.quantity || 1),
    items: [{
      item_id: product.id,
      item_name: product.name,
      item_category: product.category,
      price: product.price,
      quantity: product.quantity || 1
    }]
  });
};

export const trackRemoveFromCart = (product) => {
  trackEvent('remove_from_cart', {
    currency: 'COP',
    value: product.price * product.quantity,
    items: [{
      item_id: product.id,
      item_name: product.name,
      item_category: product.category,
      price: product.price,
      quantity: product.quantity
    }]
  });
};

export const trackBeginCheckout = (items, total) => {
  trackEvent('begin_checkout', {
    currency: 'COP',
    value: total,
    items: items.map(item => ({
      item_id: item.id,
      item_name: item.name,
      item_category: item.category,
      price: item.price,
      quantity: item.quantity
    }))
  });
};

export const trackPurchase = (order) => {
  trackEvent('purchase', {
    transaction_id: order.orderNumber,
    value: order.total,
    currency: 'COP',
    items: order.items?.map(item => ({
      item_id: item.productId,
      item_name: item.productName,
      item_category: 'product',
      price: item.productPrice,
      quantity: item.quantity
    })) || []
  });
};

export const trackViewItem = (product) => {
  trackEvent('view_item', {
    currency: 'COP',
    value: product.price,
    items: [{
      item_id: product.id,
      item_name: product.name,
      item_category: product.category,
      price: product.price
    }]
  });
};

export const trackSearch = (searchTerm) => {
  trackEvent('search', {
    search_term: searchTerm
  });
};

